



























import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import SearchPolicy from '@/mixins/search-queries/search-policy'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidatePolicies } from '@/modules/Policy/gql/policy.gql'
import { showErrors } from '@/utils/snack'
import { ICOIInput } from '@/modules/CertificateOfInsurance/interfaces/coi-form'

@Component({
  components: {
    AppTextSearch,
    AppTextField
  }
})
export default class COIFormInfo extends mixins(SearchPolicy) {
  @Prop({ type: Object as () => ICOIInput }) value!: ICOIInput

  generalLiabilityPolicies: Policy[] = []
  automobilePolicies: Policy[] = []
  umbrellaExcessPolicies: Policy[] = []
  workersCompensationPolicies: Policy[] = []
  otherPolicies: Policy[] = []

  get generalLiabilityPolicyOptions () {
    return this.generalLiabilityPolicies.map(item => {
      return {
        id: +item.id,
        name: item.policyName,
        status: item.status,
        policyNumber: item.policyNumber,
        effectiveDate: item.effectiveDate,
        expirationDate: item.expirationDate
      }
    })
  }

  get automobilePolicyOptions () {
    return this.automobilePolicies.map(item => {
      return {
        id: +item.id,
        name: item.policyName,
        status: item.status,
        policyNumber: item.policyNumber,
        effectiveDate: item.effectiveDate,
        expirationDate: item.expirationDate
      }
    })
  }

  get umbrellaExcessPolicyOptions () {
    return this.umbrellaExcessPolicies.map(item => {
      return {
        id: +item.id,
        name: item.policyName,
        status: item.status,
        policyNumber: item.policyNumber,
        effectiveDate: item.effectiveDate,
        expirationDate: item.expirationDate
      }
    })
  }

  get workersCompensationPolicyOptions () {
    return this.workersCompensationPolicies.map(item => {
      return {
        id: +item.id,
        name: item.policyName,
        status: item.status,
        policyNumber: item.policyNumber,
        effectiveDate: item.effectiveDate,
        expirationDate: item.expirationDate
      }
    })
  }

  get otherPolicyOptions () {
    return this.otherPolicies.map(item => {
      return {
        id: +item.id,
        name: item.policyName,
        status: item.status,
        policyNumber: item.policyNumber,
        effectiveDate: item.effectiveDate,
        expirationDate: item.expirationDate
      }
    })
  }

  async getGPolicies (val: string) {
    this.generalLiabilityPolicies = await this.getCandidatePolicies(val)
  }

  async getAPolicies (val: string) {
    this.automobilePolicies = await this.getCandidatePolicies(val)
  }

  async getUPolicies (val: string) {
    this.umbrellaExcessPolicies = await this.getCandidatePolicies(val)
  }

  async getWPolicies (val: string) {
    this.workersCompensationPolicies = await this.getCandidatePolicies(val)
  }

  async getOPolicies (val: string) {
    this.otherPolicies = await this.getCandidatePolicies(val)
  }

  async getCandidatePolicies (val: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidatePolicies,
        variables: {
          filter: {
            policyName: val
          },
          paging: {
            offset: 0,
            limit: 100
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      return result.data.getPolicies.policies
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
